import { render, staticRenderFns } from "./KLolRankingMatches.vue?vue&type=template&id=fd7681be&scoped=true&"
import script from "./KLolRankingMatches.vue?vue&type=script&lang=ts&"
export * from "./KLolRankingMatches.vue?vue&type=script&lang=ts&"
import style0 from "./KLolRankingMatches.vue?vue&type=style&index=0&id=fd7681be&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7681be",
  null
  
)

export default component.exports